import { render, staticRenderFns } from "./CMSGlobalSettingShow.vue?vue&type=template&id=17b6d3fe&"
import script from "./CMSGlobalSettingShow.vue?vue&type=script&lang=js&"
export * from "./CMSGlobalSettingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports